<app-main-content mode="2col" class="gsm">
  <div flex-left #leftContainer>
    <div class="gsm-error-container" *ngIf="hasLoadError">
      <mat-card>
        <p>Die Daten des gewünschten Schadenentwurfs konnten nicht geladen werden.</p>
      </mat-card>
      <button (click)="navigateToSchadenuebersicht()" id="gsm-schadenuebersicht-btn" color="primary" mat-raised-button>
        Zurück zur Übersicht
      </button>
    </div>
    <ng-container *ngIf="!hasLoadError">
      <gsm-form-history
        #gsmFormHistory
        id="gsm-form-history"
        [formHistoryData]="formHistoryModel"
        [selectedTaskId]="selectedTaskId"
        [isAbschluss]="isAbschluss"
        [loadingTaskId]="loadingTaskId"
        [uploadingTaskId]="uploadingTaskId"
        [uploadBytesLoaded]="uploadingTaskBytesLoaded"
        [uploadBytesTotal]="uploadingTaskBytesTotal"
        (saveEvent)="onHistorySave($event)"
        (editEvent)="onHistoryEdit($event)"
        (cancelEvent)="onHistoryCancel()"
        (customEvent)="onCustomEvent($event)"
        (cancelUploadEvent)="onCancelUpload(uploadingTaskId)"
        (formChangeEvent)="onHistoryChange($event)"
      ></gsm-form-history>
      <gsm-form
        #gsmForm
        id="gsm-main-form"
        [formDefinitionModel]="formDefinitionModel"
        [isLoading]="isLoading"
        [isUploading]="isUploading"
        [initLoadingError]="initLoadingError"
        [uploadBytesLoaded]="uploadBytesLoaded"
        [uploadBytesTotal]="uploadBytesTotal"
        (formChangeEvent)="handleMessage($event)"
        (customEventEvent)="onCustomEvent($event)"
        (cancelUploadEvent)="onCancelUpload()"
      ></gsm-form>
      <span (click)="onSubmit()" id="gsm-save-btn">
        <button *ngIf="!showBackButton && !showKonnexBtn"
                class="submit-btn"
                [disabled]="isNextBtnDisabled" color="primary" mat-raised-button>
          <span *ngIf="!isLoading">{{ submitTitle }}</span>
          <mat-spinner [diameter]="30" *ngIf="isLoading"></mat-spinner>
        </button>
      </span>
      <p *ngIf="!isNextBtnDisabled && !showBackButton && !showKonnexBtn" class="shortcut-hint">Weiter: Strg + Enter</p>
      <button *ngIf="showBackButton && !showKonnexBtn" (click)="navigateToSchadenuebersicht()" id="gsm-back-button"
              color="primary" mat-raised-button>Zurück zur Übersicht
      </button>
      <button
        *ngIf="showKonnexBtn"
        (click)="reportKonnex()"
        id="gsm-konnex-button"
        color="primary"
        mat-raised-button
        [disabled]="!formData?.length"
      >
        Konnexschaden melden
      </button>
    </ng-container>
    <div class="dev-instance-id" *ngIf="processInstanceId && (stage !== 'prod')">
      {{ processInstanceId }} TEST/DEV O30
    </div>
  </div>
  <div flex-right class="left-margin">
    <app-menu-card>
      <menu-card-icon-left>
        <mat-icon class="left-icon">
          playlist_add_check
        </mat-icon>
      </menu-card-icon-left>
      <menu-card-header>
        <span>Checkliste</span>
      </menu-card-header>
      <menu-card-body>
        <gsm-checklist
          [checklistItemList]="checklistItemList"
          [disableEdit]="!!selectedTaskId || isAbschluss"
          (selectChecklistItem)="onSelectChecklistItem($event)"
        >
        </gsm-checklist>
      </menu-card-body>
    </app-menu-card>
  </div>
</app-main-content>
